import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Button } from '@/ui/components/atoms/Button';
import { ExpertiseUnscheduledCard } from '../ExpertiseUnscheduledCard';
import './UnscheduledList.styles.css';

import { UnscheduledListProps } from '../../types/planning.types';

export const UnscheduledList: React.FC<UnscheduledListProps> = ({
  expertises,
  onExpertiseClick,
  onScheduleClick
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!expertises || expertises.length === 0) {
    return null;
  }

  return (
    <div className="unscheduled-list">
      <div className="unscheduled-list__header">
        <h3 className="unscheduled-list__title">
          Expertises non planifiées ({expertises.length})
        </h3>
        <Button
          variant="ghost"
          size="small"
          onClick={() => setIsExpanded(!isExpanded)}
          className="unscheduled-list__toggle"
        >
          {isExpanded ? (
            <ChevronUpIcon className="w-5 h-5" />
          ) : (
            <ChevronDownIcon className="w-5 h-5" />
          )}
        </Button>
      </div>

      {isExpanded && (
        <div className="unscheduled-list__content">
          {expertises.length > 0 ? (
            <div className="unscheduled-list__grid">
              {expertises.map(expertise => (
                <ExpertiseUnscheduledCard
                  key={expertise.id}
                  expertise={expertise}
                  onDetailClick={() => onExpertiseClick?.(expertise)}
                  onScheduleClick={() => onScheduleClick?.(expertise)}
                />
              ))}
            </div>
          ) : (
            <div className="unscheduled-list__empty">
              <p>Toutes les expertises sont planifiées</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};